<div class="parallax-container" *ngIf="restaurant" id="header">
  <div class="header-image" [ngStyle]="{
      'width.px': '100%',
      'height.px': imageHeight,
    }">
  </div>
  <!-- Рамка шапки: изображение не выходит за неё, даже если отстаёт от быстрой прокрутки -->
  <div class="parallax-clip" [ngStyle]="{ 'height.px': imageHeight }">
    <!-- Скрывается, а не удаляется: пересоздание при быстрой прокрутке мигало -->
    <div class="parallax" *ngIf="imageSrc" [ngStyle]="{
      'background-image': 'url(' + imageSrc + ')',
      'width.px': '100%',
      'height.px': imageHeight,
      'transform': 'translateY(' + parallaxOffset + 'px)',
      'opacity': opacity,
      'visibility': isParralaxVisible ? 'visible' : 'hidden',
    }"></div>
  </div>
  <div class="header-logo" *ngIf="logoSrc">
    <img [src]="logoSrc" alt="Logo" class="logo" [ngStyle]="{
      'height.px': logoSize,
      'width.px': logoSize,
      'opacity': opacity,
    }" />
  </div>
</div>
